<template>
  <div class="grade-controll" :class="readonly ? 'readonly' : ''">
    <v-popover placement="top" :key="grade.key" v-for="grade in grades" offset="0" :trigger="tooltips && tooltips[grade.key] ? 'hover' : 'none'" :autoHide="false" :html="true">
      <span @click="onClick(grade.value, grade.key)" :class="(data==grade.value?'active':'') + ' grade ' + grade.key">{{ grade.label }}</span>
      <template slot="popover">
        <div v-if="tooltips && tooltips[grade.key]"
          v-html="tooltips[grade.key].split(/(?:\r\n|\r|\n)/).map(el => { return '<p>' + el + '</p>'}).join('')"
        ></div>

        <a class="close" v-close-popover>
          <md-icon>close</md-icon>
        </a>
      </template>
    </v-popover>
    
    <!-- <v-popover offset="0" :trigger="template.grade_tooltips && template.grade_tooltips['grade_4'] ? 'hover' : 'none'" :autoHide="false" :html="true">
      <span @click="onClick(4)" :class="data==4?'active':null" class="grade grade-4">4</span>
      <template slot="popover">
        <div v-if="template.grade_tooltips && template.grade_tooltips['grade_4']"
          v-html="template.grade_tooltips['grade_4'].split(/(?:\r\n|\r|\n)/).map(el => { return '<p>' + el + '</p>'}).join('')"
        ></div>

        <a class="close" v-close-popover>
          <md-icon>close</md-icon>
        </a>
      </template>
    </v-popover>
    <v-popover offset="0" :trigger="template.grade_tooltips && template.grade_tooltips['grade_3'] ? 'hover' : 'none'" :autoHide="false" :html="true">
      <span @click="onClick(3)" :class="data==3?'active':null" class="grade grade-3">3</span>
      <template slot="popover">
        <div v-if="template.grade_tooltips && template.grade_tooltips['grade_3']"
          v-html="template.grade_tooltips['grade_3'].split(/(?:\r\n|\r|\n)/).map(el => { return '<p>' + el + '</p>'}).join('')"
        ></div>

        <a class="close" v-close-popover>
          <md-icon>close</md-icon>
        </a>
      </template>
    </v-popover>
    <v-popover offset="0" :trigger="template.grade_tooltips && template.grade_tooltips['grade_2_5'] ? 'hover' : 'none'" :autoHide="false" :html="true">
      <span @click="onClick(2)" :class="data==2?'active':null" class="grade grade-2.5">2</span>
      <template slot="popover">
        <div v-if="template.grade_tooltips && template.grade_tooltips['grade_2_5']"
          v-html="template.grade_tooltips['grade_2_5'].split(/(?:\r\n|\r|\n)/).map(el => { return '<p>' + el + '</p>'}).join('')"
        ></div>

        <a class="close" v-close-popover>
          <md-icon>close</md-icon>
        </a>
      </template>
    </v-popover>
    <v-popover offset="0" :trigger="template.grade_tooltips && template.grade_tooltips['grade_0'] ? 'hover' : 'none'" :autoHide="false" :html="true">
      <span @click="onClick(0)" :class="data==0?'active':null" class="grade grade-0">0</span>
      <template slot="popover">
        <div v-if="template.grade_tooltips && template.grade_tooltips['grade_0']"
          v-html="template.grade_tooltips['grade_0'].split(/(?:\r\n|\r|\n)/).map(el => { return '<p>' + el + '</p>'}).join('')"
        ></div>

        <a class="close" v-close-popover>
          <md-icon>close</md-icon>
        </a>
      </template>
    </v-popover> -->
  </div>
</template>

<script>
export default {
  name: "GradeControl",
  props: ["value", "readonly", "template", "grading"],
  data() {
    let tooltips = null;
    if (this.template && this.template.grade_tooltips) {
      tooltips = JSON.parse(this.template.grade_tooltips);
    }
    return {
      data: this.value === undefined || this.value === null ? null : this.value,
      tooltips: tooltips || {}
    };
  },
  computed: {
    grades() {
      if (!this.grading || !this.grading.grades.length) {
        return [];
      }
      return this.grading.grades.map(res=>res).sort((a, b)=>{
        if ( a.value < b.value ){
          return 1;
        }
        if ( a.value > b.value ){
          return -1;
        }
        return 0;
      });
    }
  },
  methods: {
    onClick(value, key) {
      if (this.readonly) {
        return;
      }
      if (this.data == value) {
        this.data = null;
        key = null;
        this.$emit("change", {
          value: this.data,
          key: key
        });
        return;
      }
      this.data = value;
      this.$emit("change", {
        value: this.data,
        key: key
      });
    }
  },
  watch: {
    value(val) {
      this.data = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.grade {
  cursor: pointer;
  display: inline-block;
  padding: 10px;
  text-align: center;
  width: 45px;
  height: 45px;
  border: 1px solid #d6d6d6;
  border-radius: 45px;
  padding: 10px 8px;
  color: #00854c;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  &.grade_fail, &.grade_pass {
    min-width: 60px;
  }
}
.excellent,
.grade_4, .grade_pass, .grade_a {
  color: #00854c;
  &.active {
    background-color: #00854c;
    color: #ffffff;
  }
}
.satisfactory,
.grade_3, .grade_i {
  &.active {
    background-color: #007dac;
    color: #ffffff;
  }
  color: #007dac;
}
.improvement,
.grade_2\.5, .grade_2 {
  &.active {
    background-color: #d04700;
    color: #ffffff;
  }
  color: #d04700;
}
.failure,
.grade_0, .grade_fail, .grade_u {
  &.active {
    background-color: #d00000;
    color: #ffffff;
  }
  color: #d00000;
}

.readonly {
  .grade,
  .grade_0,
  .grade_2,
  .grade_3,
  .grade_4 {
    color: #3e3e3e;
    background-color: #fff;
    &.active {
      background-color: #3e3e3e;
      color: #fff;
    }
  }
}
</style>
